import { render } from "./enterprise_transunion_kyb_verification.html?vue&type=template&id=2d5218fe&external"
import script from "./enterprise_transunion_kyb_verification.js?vue&type=script&lang=js&external"
export * from "./enterprise_transunion_kyb_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__